import React from "react";
// SnGrid_popup.tsx
import SinglePopup from "@widgets/commonpopup/SinglePopup";
import MultiPopup from "@widgets/commonpopup/MultiPopup";
import ResetPwdPopup from "@widgets/commonpopup/ResetPwdPopup";
import { PopupSettings } from "@widgets/commonpopup/PopupSettings";
import { showPopupModal } from "@widgets/CommonModal";
import { getSearchData, getInitPopUp } from "@shared/utils/CommonUtils";
import { ColumnConfig } from "./SnGrid_Types";
import { RowNode } from "ag-grid-enterprise";

export interface PopupSetting {
  single: any[];
  multi: any[];
  all: any[];
}

// 팝업 설정 추출 함수
export function getPopupSetting(
  colId: string,
  singlepopups: any[],
  multipopups: any[]
): PopupSetting {
  const single = singlepopups.filter((p: any) => p.cd_column === colId);
  const multi = multipopups.filter((p: any) => p.cd_column === colId);
  return {
    single,
    multi,
    all: single.length > 0 ? single : multi,
  };
}

// 팝업 헬퍼 함수 (async)
export async function popupHelper(
  node: any,
  selectedSingleSetting: any[],

  selectedMultiSetting: any[],
  popupSetting: { single: any[]; multi: any[]; all: any[] },
  colId: string,
  memoizedColumnConfig: ColumnConfig[] | undefined,
  addRow: (row: any) => void,
  gridRef: React.RefObject<any>,
  popupConditions: any
) {
  if (memoizedColumnConfig) {
    // 팝업 조건 병합 및 검색어 세팅
    console.log("colId:", colId);
    const baseConditions = node.data || {};
    const mergedConditions = popupConditions[colId]
      ? { ...baseConditions, ...popupConditions[colId] }
      : baseConditions;
    const keyValueObject = {
      str_search: node.data[colId] || "",
      ...mergedConditions,
    };
    console.log("팝업 조건 병합:", keyValueObject);
    if (selectedSingleSetting.length > 0) {
      if (popupSetting.single[0]?.cd_popup === "POPUP_PASSWORD") {
        const passwordPopup = <ResetPwdPopup />;
        const result = await showPopupModal({
          title: "비밀번호 변경",
          children: passwordPopup,
          width: "300px",
          height: "275px",
        });

        if (result !== undefined) {
          if (result === "close") {
            gridRef.current?.api.stopEditing();
            return;
          }

          if (node) {
            node.data.__pwdChanged = true;
            node.data[popupSetting.single[0].cd_column] = result; // setter 미호출
            gridRef.current?.api.refreshCells({ rowNodes: [node] }); // 렌더만 갱신
            node.setDataValue(popupSetting.single[0].cd_column, result);
          }
        }
        gridRef.current?.api.tabToNextCell();
        gridRef.current?.api.stopEditing();
        return;
      }

      if (selectedSingleSetting[0].cd_popup) {
        const popupData = getSearchData(selectedSingleSetting[0].cd_popup, "");
        const modalData = {
          title: popupData.title,
          code: selectedSingleSetting[0].cd_popup,
          formData: popupData.selectedData,
        };
        const popupSetting = PopupSettings[modalData.code];
        const { columns } = popupSetting;

        const rtn: any = await getInitPopUp(
          selectedSingleSetting[0].cd_popup,
          {}
        );
        const mergedData = { ...rtn.formData, ...keyValueObject };
        console.log("팝업 데이터 병합:", mergedData);
        const singlePopup = (
          <SinglePopup
            code={selectedSingleSetting[0].cd_popup}
            selectedData={mergedData}
            autoSearch={popupData.autoSearch}
          />
        );

        const result = await showPopupModal({
          title: popupData.title,
          children: singlePopup,
          width: popupData.width,
          height: popupData.height,
        });

        if (result) {
          if (result === "close") return;

          const resultArr = result[0];
          const transformedData = {
            code: resultArr[columns[0]] || "",
            name: resultArr[columns[1]] || "",
            spec: resultArr[columns[2]] || "",
            unit: resultArr[columns[3]] || "",
            material: resultArr[columns[4]] || "",
            ...resultArr, // 나머지 값을 그대로 추가
          };
          if (node.id !== undefined) {
            const rowNode = node; // 현재 행 가져오기
            if (rowNode && rowNode.data) {
              const columnFields = new Set(
                memoizedColumnConfig.map((col) => col.cd_column)
              );
              const columnMappings: Record<
                string,
                { target: string; source: keyof typeof transformedData }[]
              > = {
                cd_wh_ref: [
                  { target: "cd_wh_ref", source: "code" },
                  { target: "nm_wh_ref", source: "name" },
                ],
                cd_wh_isu: [
                  { target: "cd_wh_isu", source: "code" },
                  { target: "nm_wh_isu", source: "name" },
                ],
                cd_wh_rcv: [
                  { target: "cd_wh_rcv", source: "code" },
                  { target: "nm_wh_rcv", source: "name" },
                ],
                cd_wh_good: [
                  { target: "cd_wh_good", source: "code" },
                  { target: "nm_wh_good", source: "name" },
                ],
                cd_wh_bad: [
                  { target: "cd_wh_bad", source: "code" },
                  { target: "nm_wh_bad", source: "name" },
                ],
                cd_cust_prd: [
                  { target: "cd_cust_prd", source: "code" },
                  { target: "nm_cust_prd", source: "name" },
                ],
                cd_matl: [
                  { target: "cd_matl", source: "code" },
                  { target: "nm_matl", source: "name" },
                  { target: "dc_item_spec_matl", source: "spec" },
                  { target: "dc_item_unit_matl", source: "unit" },
                  { target: "dc_material_matl", source: "material" },
                ],
              };
              if (columnMappings[colId]) {
                columnMappings[colId].forEach(({ target, source }) => {
                  if (columnFields.has(target)) {
                    rowNode.setDataValue(target, transformedData[source]);
                  }
                });
              } else {
                columns.forEach((column: string) => {
                  if (columnFields.has(column)) {
                    rowNode.setDataValue(column, resultArr[column]);
                  }
                });

                // 공통말고 추가로 팝업에서 받고싶은 데이터 mapping
                let popup_apply: any;
                memoizedColumnConfig.map((col) => {
                  if (col.cd_column === colId) popup_apply = col.popup_apply;
                });

                popup_apply &&
                  popup_apply.map((data: any) => {
                    const target = data.target;
                    const source = data.source;

                    rowNode.setDataValue(target, transformedData[source]);
                  });
              }
            }
          }
          gridRef.current?.api.tabToNextCell();
          gridRef.current?.api.stopEditing();
        } else if (result === undefined) {
          if (node.id !== undefined) {
            const rowNode = node; // 현재 행 가져오기
            if (rowNode && rowNode.data) {
              const columnFields = new Set(
                memoizedColumnConfig.map((col) => col.cd_column)
              );
              const clearColumnMappings: Record<string, string[]> = {
                cd_wh_ref: ["cd_wh_ref", "nm_wh_ref"],
                cd_wh_isu: ["cd_wh_isu", "nm_wh_isu"],
                cd_wh_rcv: ["cd_wh_rcv", "nm_wh_rcv"],
                cd_wh_good: ["cd_wh_good", "nm_wh_good"],
                cd_wh_bad: ["cd_wh_bad", "nm_wh_bad"],
                cd_cust_prd: ["cd_cust_prd", "nm_cust_prd"],
                cd_matl: [
                  "cd_matl",
                  "nm_matl",
                  "dc_item_spec_matl",
                  "dc_item_unit_matl",
                  "dc_material_matl",
                ],
              };

              if (clearColumnMappings[colId]) {
                clearColumnMappings[colId].forEach((field) => {
                  if (columnFields.has(field)) {
                    rowNode.setDataValue(field, "");
                  }
                });
              } else {
                gridRef.current?.api.stopEditing();
                columns.forEach((column: string) => {
                  if (columnFields.has(column)) {
                    rowNode.setDataValue(column, "");
                  }
                });

                // 공통말고 추가로 팝업에서 받은 데이터 초기화
                let popup_apply: any;
                memoizedColumnConfig.map((col) => {
                  if (col.cd_column === colId) popup_apply = col.popup_apply;
                });

                popup_apply &&
                  popup_apply.map((data: any) => {
                    const target = data.target;
                    rowNode.setDataValue(target, "");
                  });
              }
            }
          }
        }
      }
    } else if (selectedMultiSetting.length > 0) {
      if (selectedMultiSetting[0].cd_popup) {
        const popupData = getSearchData(selectedMultiSetting[0].cd_popup, "");

        const popupSetting = PopupSettings[selectedMultiSetting[0].cd_popup];
        const { columns } = popupSetting;

        const rtn: any = await getInitPopUp(
          selectedMultiSetting[0].cd_popup,
          {}
        );
        const mergedData = { ...rtn.formData, ...keyValueObject };
        const multiPopup = (
          <MultiPopup
            code={selectedMultiSetting[0].cd_popup}
            selectedData={mergedData}
            autoSearch={popupData.autoSearch}
          />
        );
        const result = await showPopupModal({
          title: popupData.title,
          children: multiPopup,
          width: popupData.width,
          height: popupData.height,
        });

        if (result) {
          if (result === "close") return;
          if (node.id !== undefined) {
            const rowNode = node;
            if (rowNode && rowNode.data) {
              const newRows: any[] = [];
              result.forEach((selectedItem: any) => {
                const columnFields = new Set(
                  memoizedColumnConfig.map((col) => col.cd_column)
                );

                if (selectedItem === result[0]) {
                  const resultArr = result[0];
                  const transformedData = {
                    code: resultArr[columns[0]] || "",
                    name: resultArr[columns[1]] || "",
                    spec: resultArr[columns[2]] || "",
                    unit: resultArr[columns[3]] || "",
                    material: resultArr[columns[4]] || "",
                    ...resultArr, // 나머지 값을 그대로 추가
                  };

                  const columnMappings: Record<
                    string,
                    { target: string; source: keyof typeof transformedData }[]
                  > = {
                    cd_matl: [
                      { target: "cd_matl", source: "code" },
                      { target: "nm_matl", source: "name" },
                      { target: "dc_item_spec_matl", source: "spec" },
                      { target: "dc_item_unit_matl", source: "unit" },
                      { target: "dc_material_matl", source: "material" },
                    ],
                  };
                  if (columnMappings[colId]) {
                    columnMappings[colId].forEach(({ target, source }) => {
                      if (columnFields.has(target)) {
                        rowNode.setDataValue(target, transformedData[source]);
                      }
                    });
                  } else {
                    columns.forEach((column: string) => {
                      if (columnFields.has(column)) {
                        rowNode.setDataValue(column, resultArr[column]);
                      }
                    });

                    // 공통말고 추가로 팝업에서 받고싶은 데이터 mapping
                    let popup_apply: any;
                    memoizedColumnConfig.map((col) => {
                      if (col.cd_column === colId)
                        popup_apply = col.popup_apply;
                    });

                    popup_apply &&
                      popup_apply.map((data: any) => {
                        const target = data.target;
                        const source = data.source;

                        rowNode.setDataValue(target, transformedData[source]);
                      });
                  }
                } else {
                  const newRow: Record<string, any> = {};
                  if (colId === "cd_matl") {
                    newRow["cd_matl"] = selectedItem[columns[0]];
                    newRow["nm_matl"] = selectedItem[columns[1]];
                    newRow["dc_item_spec_matl"] = selectedItem[columns[2]];
                    newRow["dc_item_unit_matl"] = selectedItem[columns[3]];
                    newRow["dc_material_matl"] = selectedItem[columns[4]];
                  }

                  newRows.push(newRow);
                  addRow(newRow);

                  const rowCount = gridRef.current.api.getDisplayedRowCount();
                  const lastRowIndex = rowCount - 1;
                  const lastRowNode =
                    gridRef.current.api.getDisplayedRowAtIndex(lastRowIndex);

                  columns.forEach((col: string) => {
                    if (columnFields.has(col)) {
                      lastRowNode.setDataValue(col, selectedItem[col]);
                    }
                  });

                  // 공통말고 추가로 팝업에서 받고싶은 데이터 mapping
                  let popup_apply: any;
                  memoizedColumnConfig.map((col) => {
                    if (col.cd_column === colId) popup_apply = col.popup_apply;
                  });

                  popup_apply &&
                    popup_apply.map((data: any) => {
                      const target = data.target;
                      const source = data.source;

                      lastRowNode.setDataValue(target, selectedItem[source]);
                    });
                }
              });
            }
          }
          gridRef.current?.api.tabToNextCell();
          gridRef.current?.api.stopEditing();
        } else if (result === undefined) {
          if (node.id !== undefined) {
            const rowNode = node; // 현재 행 가져오기
            if (rowNode && rowNode.data) {
              const columnFields = new Set(
                memoizedColumnConfig.map((col) => col.cd_column)
              );
              const clearColumnMappings: Record<string, string[]> = {
                cd_wh_ref: ["cd_wh_ref", "nm_wh_ref"],
                cd_wh_isu: ["cd_wh_isu", "nm_wh_isu"],
                cd_wh_rcv: ["cd_wh_rcv", "nm_wh_rcv"],
                cd_wh_good: ["cd_wh_good", "nm_wh_good"],
                cd_wh_bad: ["cd_wh_bad", "nm_wh_bad"],
                cd_cust_prd: ["cd_cust_prd", "nm_cust_prd"],
                cd_matl: [
                  "cd_matl",
                  "nm_matl",
                  "dc_item_spec_matl",
                  "dc_item_unit_matl",
                  "dc_material_matl",
                ],
              };
              if (clearColumnMappings[colId]) {
                clearColumnMappings[colId].forEach((field) => {
                  if (columnFields.has(field)) {
                    rowNode.setDataValue(field, "");
                  }
                });
              } else {
                gridRef.current?.api.stopEditing();
                columns.forEach((column: string) => {
                  if (columnFields.has(column)) {
                    rowNode.setDataValue(column, "");
                  }
                });

                // 공통말고 추가로 팝업에서 받은 데이터 초기화
                let popup_apply: any;
                memoizedColumnConfig.map((col) => {
                  if (col.cd_column === colId) popup_apply = col.popup_apply;
                });

                popup_apply &&
                  popup_apply.map((data: any) => {
                    const target = data.target;
                    rowNode.setDataValue(target, "");
                  });
              }
            }
          }
        }
      }
    }
  }
}

export async function PopupHelper2(
  gridApi: any,
  params: any,
  popupConditions: any,
  columnConfig: ColumnConfig[],
  addRow: (row: any) => RowNode | null
) {
  if (!gridApi || !params) return;
  const rowNode = params.api.getRowNode(params.node.id);
  const popupId = params.colDef.columnConfig.cd_popup;
  const colId = params.colDef.field;
  const colType = params.colDef.columnConfig.tp_column;
  const popupApply = params.colDef.columnConfig.popup_apply;

  const popupSetting = PopupSettings[popupId];
  if (!popupSetting) return;

  const columnFields = new Set(columnConfig.map((col) => col.cd_column));

  const baseConditions = rowNode.data || {};
  const mergedConditions = popupConditions[colId]
    ? { ...baseConditions, ...popupConditions[colId] }
    : baseConditions;
  const keyValueObject = {
    str_search: rowNode.data[colId] || "",
    ...mergedConditions,
  };

  if (popupId === "POPUP_PASSWORD") {
    const passwordPopup = <ResetPwdPopup />;
    const result = await showPopupModal({
      title: "비밀번호 변경",
      children: passwordPopup,
      width: "300px",
      height: "275px",
    });

    if (result !== undefined) {
      if (result === "close") {
        return;
      }

      if (rowNode) {
        rowNode.setDataValue(colId, result);
      }
    }
    gridApi.current.tabToNextCell();
    gridApi.current.stopEditing();
    return;
  }

  if (colType === "SnCodeBox") {
    gridApi.current.stopEditing();

    const popupData = getSearchData(popupId, "");

    const { columns } = popupSetting;

    const rtn: any = await getInitPopUp(popupId, {});
    const mergedData = { ...rtn.formData, ...keyValueObject };
    const singlePopup = (
      <SinglePopup
        code={popupId}
        selectedData={mergedData}
        autoSearch={popupData.autoSearch}
      />
    );

    const result = await showPopupModal({
      title: popupData.title,
      children: singlePopup,
      width: popupData.width,
      height: popupData.height,
    });

    if (result) {
      if (result === "close") return;

      const resultArr = result[0];
      const transformedData = {
        code: resultArr[columns[0]] || "",
        name: resultArr[columns[1]] || "",
        spec: resultArr[columns[2]] || "",
        unit: resultArr[columns[3]] || "",
        material: resultArr[columns[4]] || "",
        ...resultArr, // 나머지 값을 그대로 추가
      };

      const columnMappings: Record<
        string,
        { target: string; source: keyof typeof transformedData }[]
      > = {
        cd_wh_ref: [
          { target: "cd_wh_ref", source: "code" },
          { target: "nm_wh_ref", source: "name" },
        ],
        cd_wh_isu: [
          { target: "cd_wh_isu", source: "code" },
          { target: "nm_wh_isu", source: "name" },
        ],
        cd_wh_rcv: [
          { target: "cd_wh_rcv", source: "code" },
          { target: "nm_wh_rcv", source: "name" },
        ],
        cd_wh_good: [
          { target: "cd_wh_good", source: "code" },
          { target: "nm_wh_good", source: "name" },
        ],
        cd_wh_bad: [
          { target: "cd_wh_bad", source: "code" },
          { target: "nm_wh_bad", source: "name" },
        ],
        cd_cust_prd: [
          { target: "cd_cust_prd", source: "code" },
          { target: "nm_cust_prd", source: "name" },
        ],
        cd_matl: [
          { target: "cd_matl", source: "code" },
          { target: "nm_matl", source: "name" },
          { target: "dc_item_spec_matl", source: "spec" },
          { target: "dc_item_unit_matl", source: "unit" },
          { target: "dc_material_matl", source: "material" },
        ],
      };

      if (columnMappings[colId]) {
        columnMappings[colId].forEach(({ target, source }) => {
          if (columnFields.has(target)) {
            rowNode.setDataValue(target, transformedData[source]);
          }
        });
      } else {
        columns.forEach((column: string) => {
          if (columnFields.has(column)) {
            rowNode.setDataValue(column, resultArr[column]);
          }
        });
      }

      // 공통말고 추가로 팝업에서 받고싶은 데이터 mapping
      popupApply &&
        popupApply.map((data: any) => {
          const target = data.target;
          const source = data.source;

          rowNode.setDataValue(target, transformedData[source]);
        });
      gridApi.current.tabToNextCell();
    } else {
      const clearColumnMappings: Record<string, string[]> = {
        cd_wh_ref: ["cd_wh_ref", "nm_wh_ref"],
        cd_wh_isu: ["cd_wh_isu", "nm_wh_isu"],
        cd_wh_rcv: ["cd_wh_rcv", "nm_wh_rcv"],
        cd_wh_good: ["cd_wh_good", "nm_wh_good"],
        cd_wh_bad: ["cd_wh_bad", "nm_wh_bad"],
        cd_cust_prd: ["cd_cust_prd", "nm_cust_prd"],
        cd_matl: [
          "cd_matl",
          "nm_matl",
          "dc_item_spec_matl",
          "dc_item_unit_matl",
          "dc_material_matl",
        ],
      };

      if (clearColumnMappings[colId]) {
        clearColumnMappings[colId].forEach((field) => {
          if (columnFields.has(field)) {
            rowNode.setDataValue(field, "");
          }
        });
      } else {
        columns.forEach((column: string) => {
          if (columnFields.has(column)) {
            rowNode.setDataValue(column, "");
          }
        });
      }
      // 공통말고 추가로 팝업에서 받은 데이터 초기화
      popupApply &&
        popupApply.map((data: any) => {
          const target = data.target;
          rowNode.setDataValue(target, "");
        });
    }
  } else if (colType === "SnMultiCodeBox") {
    gridApi.current.stopEditing();
    const popupData = getSearchData(popupId, "");

    const { columns } = popupSetting;

    const rtn: any = await getInitPopUp(popupId, {});
    const mergedData = { ...rtn.formData, ...keyValueObject };
    const multiPopup = (
      <MultiPopup
        code={popupId}
        selectedData={mergedData}
        autoSearch={popupData.autoSearch}
      />
    );

    const results = await showPopupModal({
      title: popupData.title,
      children: multiPopup,
      width: popupData.width,
      height: popupData.height,
    });

    if (results) {
      if (results === "close") return;
      {
        results.map((result: any, index: number) => {
          const resultArr = result;
          const transformedData = {
            code: resultArr[columns[0]] || "",
            name: resultArr[columns[1]] || "",
            spec: resultArr[columns[2]] || "",
            unit: resultArr[columns[3]] || "",
            material: resultArr[columns[4]] || "",
            ...resultArr, // 나머지 값을 그대로 추가
          };

          const columnMappings: Record<
            string,
            { target: string; source: keyof typeof transformedData }[]
          > = {
            cd_wh_ref: [
              { target: "cd_wh_ref", source: "code" },
              { target: "nm_wh_ref", source: "name" },
            ],
            cd_wh_isu: [
              { target: "cd_wh_isu", source: "code" },
              { target: "nm_wh_isu", source: "name" },
            ],
            cd_wh_rcv: [
              { target: "cd_wh_rcv", source: "code" },
              { target: "nm_wh_rcv", source: "name" },
            ],
            cd_wh_good: [
              { target: "cd_wh_good", source: "code" },
              { target: "nm_wh_good", source: "name" },
            ],
            cd_wh_bad: [
              { target: "cd_wh_bad", source: "code" },
              { target: "nm_wh_bad", source: "name" },
            ],
            cd_cust_prd: [
              { target: "cd_cust_prd", source: "code" },
              { target: "nm_cust_prd", source: "name" },
            ],
            cd_matl: [
              { target: "cd_matl", source: "code" },
              { target: "nm_matl", source: "name" },
              { target: "dc_item_spec_matl", source: "spec" },
              { target: "dc_item_unit_matl", source: "unit" },
              { target: "dc_material_matl", source: "material" },
            ],
          };
          if (index === 0) {
            if (columnMappings[colId]) {
              columnMappings[colId].forEach(({ target, source }) => {
                if (columnFields.has(target)) {
                  rowNode.setDataValue(target, transformedData[source]);
                }
              });
            } else {
              columns.forEach((column: string) => {
                if (columnFields.has(column)) {
                  rowNode.setDataValue(column, resultArr[column]);
                }
              });

              // 공통말고 추가로 팝업에서 받고싶은 데이터 mapping
              popupApply &&
                popupApply.map((data: any) => {
                  const target = data.target;
                  const source = data.source;
                  rowNode.setDataValue(target, transformedData[source]);
                });
            }
          } else {
            console.log("result", result, index);

            const addNode: RowNode | null = addRow({});
            console.log("addNode", addNode);

            if (addNode) {
              if (columnMappings[colId]) {
                columnMappings[colId].forEach(({ target, source }) => {
                  if (columnFields.has(target)) {
                    addNode.setDataValue(target, transformedData[source]);
                  }
                });
              } else {
                columns.forEach((column: string) => {
                  if (columnFields.has(column)) {
                    addNode.setDataValue(column, resultArr[column]);
                  }
                });

                // 공통말고 추가로 팝업에서 받고싶은 데이터 mapping
                popupApply &&
                  popupApply.map((data: any) => {
                    const target = data.target;
                    const source = data.source;
                    addNode.setDataValue(target, transformedData[source]);
                  });
              }
            }
          }
        });
      }

      gridApi.current.tabToNextCell();
      gridApi.current.stopEditing();
    } else {
      const clearColumnMappings: Record<string, string[]> = {
        cd_wh_ref: ["cd_wh_ref", "nm_wh_ref"],
        cd_wh_isu: ["cd_wh_isu", "nm_wh_isu"],
        cd_wh_rcv: ["cd_wh_rcv", "nm_wh_rcv"],
        cd_wh_good: ["cd_wh_good", "nm_wh_good"],
        cd_wh_bad: ["cd_wh_bad", "nm_wh_bad"],
        cd_cust_prd: ["cd_cust_prd", "nm_cust_prd"],
        cd_matl: [
          "cd_matl",
          "nm_matl",
          "dc_item_spec_matl",
          "dc_item_unit_matl",
          "dc_material_matl",
        ],
      };

      if (clearColumnMappings[colId]) {
        clearColumnMappings[colId].forEach((field) => {
          if (columnFields.has(field)) {
            rowNode.setDataValue(field, "");
          }
        });
      } else {
        gridApi.current.stopEditing();
        columns.forEach((column: string) => {
          if (columnFields.has(column)) {
            rowNode.setDataValue(column, "");
          }
        });

        // 공통말고 추가로 팝업에서 받은 데이터 초기화
        popupApply &&
          popupApply.map((data: any) => {
            const target = data.target;
            rowNode.setDataValue(target, "");
          });
      }
    }
  }
}

// 팝업 관련 데이터 삭제 함수
export function deleteKeyDown(
  event: any,
  selectedSingleSetting: any[],
  selectedMultiSetting: any[],
  popupSetting: { single: any[]; multi: any[]; all: any[] },
  colId: string,
  memoizedColumnConfig: ColumnConfig[] | undefined
) {
  const Setting = PopupSettings[popupSetting.single[0]?.cd_popup];
  const { columns } = Setting;
  const rowNode = event.node; // 현재 행 가져오기
  if (rowNode && rowNode.data) {
    if (memoizedColumnConfig) {
      const columnFields = new Set(
        memoizedColumnConfig.map((col) => col.cd_column)
      );
      const clearColumnMappings: Record<string, string[]> = {
        cd_wh_ref: ["cd_wh_ref", "nm_wh_ref"],
        cd_wh_isu: ["cd_wh_isu", "nm_wh_isu"],
        cd_wh_rcv: ["cd_wh_rcv", "nm_wh_rcv"],
        cd_wh_good: ["cd_wh_good", "nm_wh_good"],
        cd_wh_bad: ["cd_wh_bad", "nm_wh_bad"],
        cd_cust_prd: ["cd_cust_prd", "nm_cust_prd"],
        cd_matl: [
          "cd_matl",
          "nm_matl",
          "dc_item_spec_matl",
          "dc_item_unit_matl",
          "dc_material_matl",
        ],
      };

      if (clearColumnMappings[colId]) {
        clearColumnMappings[colId].forEach((field) => {
          if (columnFields.has(field)) {
            rowNode.setDataValue(field, "");
          }
        });
      } else {
        columns.forEach((column: string) => {
          if (columnFields.has(column)) {
            rowNode.setDataValue(column, "");
          }
        });
      }
    }
  }
}
